<form class="login-form" (submit)="onSubmit($event)">
    <dx-form
        labelLocation="top"
        [formData]="formData"
        [disabled]="loading"
        [showColonAfterLabel]="true"
    >
        <dxi-item
            dataField="email"
            editorType="dxTextBox"
            [editorOptions]="emailEditorOptions"
        >
            <dxi-validation-rule type="required" message="Email is required"></dxi-validation-rule>
            <dxi-validation-rule type="email" message="Email is invalid"></dxi-validation-rule>
            <dxo-label text="Email"></dxo-label>
        </dxi-item>

        <dxi-item
            dataField="password"
            editorType="dxTextBox"
            [editorOptions]="passwordEditorOptions"
        >
            <dxi-validation-rule type="required" message="Password is required"></dxi-validation-rule>
            <dxo-label text="Password"></dxo-label>
        </dxi-item>

        <dxi-item
            dataField="rememberMe"
            editorType="dxCheckBox"
            [editorOptions]="{
                text: 'Remember me',
                elementAttr: { class: 'form-text' }
            }"
        >
            <dxo-label [visible]="false"></dxo-label>
        </dxi-item>

        <dxi-item itemType="button">
            <dxo-button-options
                width="100%"
                type="default"
                [useSubmitBehavior]="true"
                [template]="'signInTemplate'"
            >
            </dxo-button-options>
        </dxi-item>

        <ng-container *dxTemplate="let item of 'signInTemplate'">
            <span class="dx-button-text">
                @if (loading) {
                    <dx-load-indicator width="24px" height="24px" [visible]="true"></dx-load-indicator>
                } @else {
                    Sign In
                }
            </span>
        </ng-container>
    </dx-form>

    <div class="reset-link">
        <a [routerLink]="resetLink">Forgot password?</a>
    </div>
</form>
